import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['emailSelect', 'firstName', 'lastName', 'phone']

  fill () {
    const select = this.emailSelectTarget.tomselect
    const option = select ? select.options[this.emailSelectTarget.value] : null
    const isExistingUser = Boolean(option && option.first_name)

    if (isExistingUser) {
      this.#apply(this.firstNameTarget, option.first_name, true)
      this.#apply(this.lastNameTarget, option.last_name, true)
      this.#apply(this.phoneTarget, option.phone, true)
    } else {
      this.#apply(this.firstNameTarget, '', false)
      this.#apply(this.lastNameTarget, '', false)
      this.#apply(this.phoneTarget, '', false)
    }
  }

  #apply (input, value, readonly) {
    if (!input) return

    input.value = value
    input.readOnly = readonly
    input.classList.toggle('bg-gray-50', readonly)
    input.classList.toggle('text-gray-700', readonly)
  }
}
